<template>
  <div class="get-coupon">
    <Swipe></Swipe>
    <Guide></Guide>
    <Coupons></Coupons>
    <Coupons></Coupons>
  </div>
</template>

<script>
import Guide from './comps/guide.vue'
import Swipe from './comps/swipe.vue'
import Coupons from './comps/coupons.vue'
import { getCouponFloorData } from '@/api/floor'

export default {
  name: 'getCoupon',
  components: { Swipe, Guide, Coupons },
  data() {
    return {}
  },
  mounted() {
    getCouponFloorData({ pageId: '20220608053220h4cddroiya' }).then(res => {
      if (res.code === 200) {
        console.log(res)
      }
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.get-coupon{
  background-color: #F9F9F9;
}
</style>
